import { useState, useEffect } from "react";
import { useDefaultLogo } from "@/hooks/useDefaultLogo";

interface LogoProps {
  customLogoUrl?: string | null;
  size?: "sm" | "md" | "lg";
}

export function Logo({ customLogoUrl, size = "md" }: LogoProps) {
  const [imageError, setImageError] = useState(false);
  const { defaultLogoUrl } = useDefaultLogo();
  
  // Use custom logo if provided, otherwise use default from platform settings
  const logoUrl = customLogoUrl || defaultLogoUrl;

  // Handle image errors
  useEffect(() => {
    if (logoUrl) {
      setImageError(false);
      
      const img = new Image();
      img.onerror = () => setImageError(true);
      img.src = logoUrl;
    }
  }, [logoUrl]);

  // Size classes for different contexts
  const sizeClasses = {
    sm: "h-8 w-auto",
    md: "h-10 md:h-12 w-auto",
    lg: "h-12 w-auto"
  };

  // Show logo if no error
  if (!imageError) {
    return (
      <div className="flex items-center gap-2">
        <img 
          src={logoUrl} 
          alt="North Reports Logo" 
          className={`${sizeClasses[size]} object-contain max-w-full`}
        />
      </div>
    );
  }

  // Fallback text if image fails to load
  return (
    <div className="flex items-center gap-2">
      <span className={`font-bold ${size === 'sm' ? 'text-xl' : size === 'lg' ? 'text-3xl' : 'text-2xl'} bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent`}>
        North
      </span>
      <span className={`font-light ${size === 'sm' ? 'text-xl' : size === 'lg' ? 'text-3xl' : 'text-2xl'} text-foreground`}>
        Reports
      </span>
    </div>
  );
}
